// src/hooks/useBoolean.ts
import { useCallback, useState } from "react";
function useBoolean(defaultValue) {
  const [value, setValue] = useState(!!defaultValue);
  const setTrue = useCallback(() => setValue(true), []);
  const setFalse = useCallback(() => setValue(false), []);
  const toggle = useCallback(() => setValue((prev) => !prev), []);
  return {
    value,
    setTrue,
    setFalse,
    toggle
  };
}

export {
  useBoolean
};
